import React, { memo, useCallback, useState } from 'react';
import {
  PasswordHashTextInput,
  PasswordHashAuthPropertyFree,
  FormPageAuthInputItemPasswordHashFree,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type PasswordHash = FormPageAuthInputItemPasswordHashFree['password'];

type Props = FormFieldInputItemProps<
  PasswordHashAuthPropertyFree,
  FormPageAuthInputItemPasswordHashFree
> & {
  password: PasswordHash;
};

const SYNERGY_ID_KEY: Extract<
  keyof FormPageAuthInputItemPasswordHashFree,
  'password'
> = 'password';

export const PasswordHashFree: React.FC<Props> = memo(
  ({ property, disabled, design, password, onChange, onBlur, className }) => {
    const [displayPassword, setDisplayPassword] = useState(false);
    const { propertyId } = property;
    const { placeholder, passwordDisplayLabel } = property.detail.inputFormat;
    const handleChange = (password: PasswordHash) => {
      onChange(SYNERGY_ID_KEY, password);
    };
    const handleBlur = (password: PasswordHash) => {
      onBlur(SYNERGY_ID_KEY, password);
    };
    const handlePasswordDisplayChange = useCallback(() => {
      setDisplayPassword((prev) => !prev);
    }, []);
    return (
      <PasswordHashTextInput
        propertyId={propertyId}
        placeholder={placeholder}
        value={password ?? ''}
        displayPassword={displayPassword}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        passwordDisplayLabel={passwordDisplayLabel}
        onPasswordDisplayChange={handlePasswordDisplayChange}
        design={design}
        className={className}
      />
    );
  }
);
